import { orderBy, sortBy } from 'lodash'

export const order = orderBy
export const sort = sortBy

export function compType (compare, return1, return2, return3) {
  return compare === 'N' ? return1 : (compare === 'C' ? return2 : return3 )
}
